import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";
import { lazy } from "react";

const MachineDetailsPageContent = lazy(() => import("./MachineDetailsPageContent"));

function MachineDetailsPageInternal() {
    return (
        <DefaultPage>
            <MachineDetailsPageContent />
        </DefaultPage>
    );
}

export const MachineDetailsPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE)
)(MachineDetailsPageInternal);
